import axiosInstance from '../../config/axiosInstance';

export interface NotificationSettings {
  telegramLinked: boolean;
}

export interface TelegramLink {
  deepLink: string;
  botUsername: string;
}

class NotificationSettingsService {
  private readonly BASE = '/users/me';

  async getSettings(): Promise<NotificationSettings> {
    return axiosInstance.get(`${this.BASE}/notifications`);
  }

  async connectTelegram(language?: string): Promise<TelegramLink> {
    // Forward the app locale so Telegram messages match the app language
    // rather than the user's Telegram client UI locale.
    // Body MUST be an object, not null: with the default application/json
    // content type a null body serializes to "null", which the backend's JSON
    // parser rejects with 400 "is not valid JSON". The endpoint reads the
    // language from the query string, so an empty object is all we need.
    return axiosInstance.post(`${this.BASE}/telegram-link`, {}, {
      params: language ? { language } : undefined,
    });
  }

  async disconnect(): Promise<void> {
    return axiosInstance.delete(`${this.BASE}/telegram-link`);
  }

  // Persist the app locale so Telegram notifications follow the app language
  // and stay in sync when the user switches it, not just at link time.
  async setLanguage(language: string): Promise<void> {
    return axiosInstance.patch(`${this.BASE}/language`, { language });
  }
}

export const notificationSettingsService = new NotificationSettingsService();
